export function resourcesSlider() {
    const slider = $(".resources-list");

    function sliderInit(){
        slider.slick({
            slidesToScroll: 1,
            slidesToShow: 1.2,
            dots: true,
            arrows: false,
            mobileFirst:true,
            infinite:false,
            responsive: [
                {
                    breakpoint: 767,
                    settings: "unslick"
                }
            ]
        })
    }

    $(window).on("load resize", function () {
        if (window.innerWidth < 768 && !slider.hasClass("slick-initialized")) {
            sliderInit();
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/resourcesSlider.js